import firebase from 'firebase/app';

import { ScreenStoreHour } from './screen-store-hour.model';
import { ScreenImage } from '../constants';

export type ScreenListingStatus = 'DRAFT' | 'PENDING' | 'APPROVED' | 'REJECTED';
export type ScreenType = 'TV Screen' | 'LED Billboard';

export class ScreenListing {
  id: string;
  ownerId: string;
  firestickId: string;
  createdAt?: firebase.firestore.Timestamp;
  updatedAt: firebase.firestore.Timestamp;
  status: ScreenListingStatus;
  isActive: boolean;

  screenName: string;
  locationType: string;
  address_components: any;
  address: string;
  locality: string;
  city: string;
  state: string;
  country: string;
  countryCode: string;
  phoneNumber: string;
  languages: string[];
  pincode: number;
  monthlyFootfall: number;
  genderRatio: number;
  operateType: string;
  storeHours: ScreenStoreHour[];

  screenPrice: number;
  screenDescription: string;
  screenRestrictions: string;
  screenType: ScreenType;

  screenSize: number;
  screenOrientation: string;
  screenResolution: string;

  screenWidth: number;
  screenHeight: number;
  screenResolutionWidth: number;
  screenResolutionHeight: number;

  screenImages: ScreenImage[];
  screenPlace: string;
  latitude: number;
  longitude: number;
  screenCategories: string[];
  timezoneOffset: number;
  isScreenAvailableForBooking: boolean;

  concernedPersonName: string;
  businessName: string;

  constructor(
    id?: string,
    ownerId?: string,
    firestickId?: string,
    createdAt?: firebase.firestore.Timestamp,
    updatedAt?: firebase.firestore.Timestamp,
    status?: ScreenListingStatus,
    isActive?: boolean,

    screenName?: string,
    locationType?: string,
    address_components?: any,
    address?: string,
    locality?: string,
    city?: string,
    state?: string,
    country?: string,
    countryCode?: string,
    phoneNumber?: string,
    languages?: string[],
    pincode?: number,
    monthlyFootfall?: number,
    genderRatio?: number,
    operateType?: string,
    storeHours?: ScreenStoreHour[],

    screenPrice?: number,
    screenDescription?: string,
    screenRestrictions?: string,
    screenType?: ScreenType,
    screenOrientation?: string,
    screenResolution?: string,
    screenWidth?: number,
    screenHeight?: number,
    screenPlace?: string,
    screenImages?: ScreenImage[],
    latitude?: number,
    longitude?: number,
    screenCategories?: string[],
    timezoneOffset?: number,
    isScreenAvailableForBooking?: boolean,
    concernedPersonName?: string,
    businessName?: string
  ) {
    this.id = id || null;
    this.ownerId = ownerId || null;
    this.firestickId = firestickId || null;
    this.createdAt = createdAt || firebase.firestore.Timestamp.now();
    this.updatedAt = updatedAt || firebase.firestore.Timestamp.now();
    this.status = status || 'DRAFT';
    this.isActive = isActive || false;
    this.screenName = screenName || null;
    this.locationType = locationType || null;
    this.address_components = address_components || null;
    this.address = address || null;
    this.locality = locality || null;
    this.city = city || null;
    this.languages = languages || null;
    this.state = state || null;
    this.country = country || null;
    this.countryCode = countryCode || null;
    this.phoneNumber = phoneNumber || null;
    this.pincode = pincode || null;
    this.genderRatio = genderRatio || null;
    this.monthlyFootfall = monthlyFootfall || null;
    this.operateType = operateType || null;
    this.storeHours = storeHours || [];
    this.screenPrice = screenPrice || null;
    this.screenDescription = screenDescription || null;
    this.screenRestrictions = screenRestrictions || null;
    this.screenType = screenType || 'TV Screen';
    this.screenOrientation = screenOrientation || null;
    this.screenResolution = screenResolution || null;
    this.screenWidth = screenWidth || null;
    this.screenHeight = screenHeight || null;
    this.screenImages = screenImages || [];
    this.screenPlace = screenPlace || null;
    this.latitude = latitude || null;
    this.longitude = longitude || null;
    this.screenCategories = screenCategories || [];
    this.timezoneOffset = timezoneOffset || 0;
    this.isScreenAvailableForBooking = isScreenAvailableForBooking || false;
    this.concernedPersonName = concernedPersonName || null;
    this.businessName = businessName || null;
  }
}
